import { render, staticRenderFns } from "./TaskCodeLabel.component.vue?vue&type=template&id=eb02a602&scoped=true&"
import script from "./TaskCodeLabel.component.vue?vue&type=script&lang=js&"
export * from "./TaskCodeLabel.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb02a602",
  null
  
)

export default component.exports